import React from "react";
const OtusProContact = () => {
    return (
        <div className="screen">
            <strong>Otus Pro Support</strong>
            <p>
                Welcome to the official support page for Otus Pro by Edenlux Inc.<br/><br/>

                If you need help using Otus Pro, please contact our support team.<br/>
                <b>Email:</b> <a href="mailto:cs@edenlx.com">cs@edenlx.com</a><br /><br />
            </p>
            <br /><br />
        </div>
    )
}
export default OtusProContact